import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

const WARNA = { hijau: "bg-emerald-500", kuning: "bg-amber-400", merah: "bg-red-500" };
const LABEL = { hijau: "Kondisi Baik", kuning: "Perlu Perhatian", merah: "Perlu Penanganan Segera" };

// Muat peta status kondisi sekali untuk daftar binaan.
export const useStatusKondisi = () => {
  const [data, setData] = useState({ items: {}, bisa_ubah: false });
  const load = () => api.get("/pastoral/status-kondisi").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  return { ...data, reload: load };
};

// Titik warna di samping nama; Care Leader bisa klik untuk mengubah, role lain read-only.
export const StatusKondisiDot = ({ jemaatId, status, bisaUbah, onChanged }) => {
  const [buka, setBuka] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const btn = useRef(null);
  const toggle = () => {
    if (!buka && btn.current) { const r = btn.current.getBoundingClientRect(); setPos({ top: r.bottom + 4, left: r.left }); }
    setBuka((b) => !b);
  };
  useEffect(() => { if (!buka) return; const tutup = () => setBuka(false); window.addEventListener("scroll", tutup, true); window.addEventListener("resize", tutup); return () => { window.removeEventListener("scroll", tutup, true); window.removeEventListener("resize", tutup); }; }, [buka]);
  const simpan = async (s) => {
    try { await api.put(`/pastoral/status-kondisi/${jemaatId}`, { status: s }); toast.success(`Status: ${LABEL[s]}`); setBuka(false); onChanged?.(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const dot = <span className={`inline-block h-3 w-3 rounded-full ring-2 ring-white shadow ${status ? WARNA[status] : "bg-slate-300"}`} />;
  const title = status ? LABEL[status] : "Status kondisi belum ditetapkan";
  if (!bisaUbah) return <span title={title} aria-label={title} className="inline-flex items-center" data-testid={`kondisi-dot-${jemaatId}`} data-status={status || "none"}>{dot}</span>;
  return (
    <span className="inline-flex items-center">
      <button ref={btn} type="button" onClick={toggle} title={`${title} — klik untuk mengubah`} className="inline-flex items-center rounded-full p-0.5 hover:bg-slate-100" data-testid={`kondisi-dot-${jemaatId}`} data-status={status || "none"}>{dot}</button>
      {buka && createPortal(
        <>
          <div className="fixed inset-0 z-[90]" onClick={() => setBuka(false)} />
          <div className="fixed z-[100] w-60 rounded-xl border bg-white shadow-xl p-1 text-sm" style={{ top: pos.top, left: pos.left }} data-testid={`kondisi-menu-${jemaatId}`}>
            {Object.keys(LABEL).map((s) => (
              <button key={s} type="button" onClick={() => simpan(s)} className={`w-full flex items-center gap-2 rounded-lg px-3 py-2 text-left hover:bg-slate-50 ${status === s ? "font-semibold" : ""}`} data-testid={`kondisi-pilih-${s}-${jemaatId}`}>
                <span className={`h-3 w-3 rounded-full ${WARNA[s]}`} />{LABEL[s]}
              </button>
            ))}
          </div>
        </>, document.body)}
    </span>
  );
};
